import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import AuthContainer from "../../pages/home/auth-container";

interface AuthModalContainerProps {
  onClose: () => void;
}

const ModalOverlay = styled.div<{ isExiting: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  z-index: 1002;
  overflow: hidden;
  opacity: ${({ isExiting }) => (isExiting ? 0 : 1)};
  transition: opacity 0.3s ease-in-out;
  @media (min-width: 1440px) {
    padding-right: calc((100vw - 1440px) / 2 + 16px);
  }
`;

const ModalContent = styled.div<{ isAnimating: boolean }>`
  width: 100%;
  max-width: 460px;
  overflow: hidden;
  transform: translateY(${({ isAnimating }) => (isAnimating ? "-100%" : "0")});
  transition: transform 0.4s ease-in-out;
`;

const AuthModalContainer: React.FC<AuthModalContainerProps> = ({ onClose }) => {
  const location = useLocation();
  const [isExiting, setIsExiting] = useState(false);
  // Start with the content above the viewport
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    // Trigger the entrance animation after a very brief delay
    const timer = setTimeout(() => {
      setIsAnimating(false);
    }, 10);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "";
    };
  }, []);

  const handleClose = () => {
    setIsAnimating(true);
    setIsExiting(true);
    // Wait for animation to complete before actually closing
    setTimeout(() => {
      onClose();
    }, 400); // This should match the transition duration
  };

  return (
    <ModalOverlay onClick={handleClose} isExiting={isExiting}>
      <ModalContent
        onClick={e => e.stopPropagation()}
        isAnimating={isAnimating}
      >
        <AuthContainerWrapper>
          <AuthContainer closeHandler={handleClose} />
        </AuthContainerWrapper>
      </ModalContent>
    </ModalOverlay>
  );
};

// This wrapper modifies the styling of AuthContainer for modal use
const AuthContainerWrapper = styled.div`
  overflow: hidden;

  .auth-container {
    position: relative;
    top: 0;
    right: 0;
    transform: none !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 0 0 8px 8px;
    max-height: 100vh;
    overflow-y: hidden;
    overflow-x: hidden;
    width: 100%;
    background-color: white;

    @media (max-width: 768px) {
      max-width: 98%;
      margin: 0 auto;
      border-radius: 0 0 8px 8px;
    }
  }
`;

export default AuthModalContainer;
